<template>
  <div
    class="info-tag"
    :class="[
      `info-tag--${size}`,
      {
        'info-tag-warning': type === 'warning',
        'info-tag-success': type === 'success',
        'info-tag--info': type === 'info',
        'info-tag-some': type === 'some',
        'info-tag-failure': type === 'failure',
        'info-tag--gradient gradient-animation': type === 'gradient',
      }]"
  >
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [Number, String, Object],
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
    size: {
      type: String,
      default: 'medium',
      validator: (value) => ['small', 'medium', 'large'].includes(value)
    },
  },
}
</script>

<style>
.info-tag {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 150px;
  font-size: 14px;
  border-radius: 37px;
  padding: 8px 16px;
  font-family: 'Montserrat';
  width: fit-content;
}
.info-tag--small {
  min-width: unset;
  padding: 1px 3px;
  border-radius: 4px;
  font-size: var(--Size-S, 12px);
}
.info-tag-warning {
  background-color: var(--warning-70);
  color: var(--warning);
}
.info-tag-success {
  background-color: var(--green-75);
  color: var(--green);
}
.info-tag-some {
  background-color: var(--yellow-25);
  color: var(--yellow);
}
.info-tag-failure {
  background-color: var(--red-25);
  color: var(--lipstick);
}
.info-tag--info {
  min-width: auto;
  color: var(--Brand-Main, #194bfb);
  padding: 2px 8px;
  border-radius: 16px;
  background: var(--Brand-100, rgba(25, 75, 251, 0.1));
  font-weight: 500;
  line-height: var(--Line-Height-L, 20px);
  letter-spacing: var(--Letter-Spacing-S, -0.2px);
}
.info-tag--gradient {
  color: var(--Basic-A-900, #FFF);
  font-weight: 600;
  line-height: var(--Line-Height-S, 16px);  
  background: var(--Accent-Main); 
  background-size: 150% 150%;
}

@media (max-width: 1279px) {
  .info-tag {
    font-size: 12px;
    padding: 6px 8px;
  }
  .info-tag.info-tag--info {
    padding: 2px 8px;
  }
  .info-tag--small {
    padding: 1px 3px;
  }
}
</style>
